import { Link } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import { BgImage } from "gbimage-bridge";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import { MdKeyboardArrowRight } from "react-icons/md";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const CaseStudies = ({ caseStudies }) => {
	// If there's no data or caseStudies is empty, return nothing.
	if (!caseStudies || caseStudies.length === 0) return null;

	return (
		<section className="py-5 py-lg-7">
			<Container>
				<Row>
					<Col>
						{caseStudies.length > 1 ? (
							/* --------------------------------
                 Render a Carousel if > 1 items
               -------------------------------- */
							<div style={{ position: "relative" }}>
								<Carousel
									responsive={{
										// Single item for all breakpoints
										allDevices: {
											breakpoint: { max: 4000, min: 0 },
											items: 1,
										},
									}}
									className="pb-9"
									infinite
									autoPlay
									showDots
									renderDotsOutside
									customLeftArrow={<CustomLeftArrow />}
									customRightArrow={<CustomRightArrow />}
									itemClass="carousel-item-padding"
								>
									{caseStudies.map((study) => {
										const bgImage = getImage(
											study.caseStudyFields.featuredImage.localFile
										);
										return (
											<BgImage
												key={study.id}
												image={bgImage}
												className="carousel-item position-relative big-case-study"
												style={carouselItemStyles}
											>
												<div
													className="position-absolute h-100 w-100 top-0 start-0"
													style={{
														background:
															"linear-gradient(180deg, rgba(0, 18, 33, 0.00) 43.38%, #001221 100%)",
													}}
												></div>
												<div
													style={{ zIndex: 2 }}
													className="position-relative w-100 p-3 p-md-5 d-flex align-items-end h-100 text-white"
												>
													<div>
														<h2>{study.title}</h2>
														<p>{study.caseStudyFields.description}</p>
														<div className="d-flex align-items-center">
															<Link
																className="outfit-regular text-decoration-none white-link mb-0 pb-0"
																to={`/case-studies/${study.slug}`}
															>
																Learn More{" "}
															</Link>
															<span>
																<MdKeyboardArrowRight className="fs-5 ms-1" />
															</span>
														</div>
													</div>
												</div>
											</BgImage>
										);
									})}
								</Carousel>
							</div>
						) : (
							/* ----------------------------------
                 Render SINGLE item if only 1 study
               ---------------------------------- */
							<SingleCaseStudyItem caseStudy={caseStudies[0]} />
						)}
					</Col>
				</Row>
			</Container>
		</section>
	);
};

/* ----------------------
   Single Case Study Item
   ---------------------- */
const SingleCaseStudyItem = ({ caseStudy }) => {
	const bgImage = getImage(caseStudy.caseStudyFields.featuredImage.localFile);

	return (
		<BgImage
			image={bgImage}
			className="position-relative big-case-study"
			style={carouselItemStyles}
		>
			<div
				className="position-absolute h-100 w-100 top-0 start-0"
				style={{
					background:
						"linear-gradient(180deg, rgba(0, 18, 33, 0.00) 43.38%, #001221 100%)",
				}}
			></div>
			<div
				style={{ zIndex: 2 }}
				className="position-relative w-100 p-3 p-md-5 d-flex align-items-end h-100 text-white"
			>
				<div>
					<h2>{caseStudy.title}</h2>
					<p>{caseStudy.caseStudyFields.description}</p>
					<div className="d-flex align-items-center">
						<Link
							className="outfit-regular text-decoration-none white-link mb-0 pb-0"
							to={`/case-studies/${caseStudy.slug}`}
						>
							Learn More{" "}
						</Link>
						<span>
							<MdKeyboardArrowRight className="fs-5 ms-1" />
						</span>
					</div>
				</div>
			</div>
		</BgImage>
	);
};

// Custom Left Arrow
const CustomLeftArrow = ({ onClick }) => (
	<button
		onClick={onClick}
		className="custom-arrow custom-left-arrow"
		style={{ ...arrowStyles2, right: "60px" }}
	>
		<FaArrowLeft className="fs-5" />
	</button>
);

// Custom Right Arrow
const CustomRightArrow = ({ onClick }) => (
	<button
		onClick={onClick}
		className="custom-arrow custom-right-arrow"
		style={{ ...arrowStyles2, right: "0px" }}
	>
		<FaArrowRight className="fs-5" />
	</button>
);

// Inline styles
const carouselItemStyles = {
	position: "relative",
	borderRadius: "12px",
	backgroundSize: "cover",
	backgroundPosition: "center",
	overflow: "hidden",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
};

const arrowStyles2 = {
	position: "absolute",
	bottom: "0px",
	transform: "translateY(-50%)",
	zIndex: 2,
	backgroundColor: "white",
	border: "1px solid #00304B",
	borderRadius: "50%",
	width: "50px",
	height: "50px",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	cursor: "pointer",
	boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
};

export default CaseStudies;
